export const BaseApi =process.env.LIB_BACK_NODE || 'https://cs.omidshayan.dev/';
export const BaseUrl =process.env.LIB_BACK_NODE || 'https://cs.omidshayan.dev/api/v1/';